module.exports = __webpack_public_path__ + "static/media/17b-03_Substance-2017-200x300cm-oleo-sobre-madera.7c7ac39b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17b/17b-03_Substance-2017-200x300cm-oleo-sobre-madera.jpg
// module id = 209
// module chunks = 0